"use strict";
/**
 * @fileoverview User role and permission enumeration for REST API
 * Represents the REST API version of user roles and permissions
 *
 * This is a direct copy of the database enum since enums don't require transformations
 * but keeping it in models maintains consistency and decoupling from database models
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPermission = exports.UserRole = void 0;
var UserRole;
(function (UserRole) {
    UserRole["SUPERADMIN"] = "superadmin";
    UserRole["ADMIN"] = "admin";
    UserRole["SELLER"] = "seller";
    UserRole["EXTERNAL_SELLER"] = "external_seller";
    UserRole["PRODUCTION_DEPT"] = "production_dept";
    UserRole["PRODUCTION_WORKER"] = "production_worker";
})(UserRole || (exports.UserRole = UserRole = {}));
/**
 * User permission enumeration
 * Fine-grained permissions that can be assigned to users
 */
var UserPermission;
(function (UserPermission) {
    // Order Management
    UserPermission["ORDERS_VIEW"] = "orders.view";
    UserPermission["ORDERS_CREATE"] = "orders.create";
    UserPermission["ORDERS_EDIT"] = "orders.edit";
    UserPermission["ORDERS_DELETE"] = "orders.delete";
    UserPermission["ORDERS_CHANGE_STATUS"] = "orders.changeStatus";
    UserPermission["ORDERS_EXPORT"] = "orders.export";
    UserPermission["ORDERS_PRINT"] = "orders.print";
    UserPermission["ORDERS_ARCHIVE"] = "orders.archive";
    UserPermission["ORDERS_WORK_ORDER_PRINT"] = "orders.workOrderPrint";
    // Customer Management
    UserPermission["CUSTOMERS_VIEW"] = "customers.view";
    UserPermission["CUSTOMERS_CREATE"] = "customers.create";
    UserPermission["CUSTOMERS_EDIT"] = "customers.edit";
    UserPermission["CUSTOMERS_DELETE"] = "customers.delete";
    UserPermission["CUSTOMERS_ARCHIVE"] = "customers.archive";
    // Product Management
    UserPermission["PRODUCTS_VIEW"] = "products.view";
    UserPermission["PRODUCTS_CREATE"] = "products.create";
    UserPermission["PRODUCTS_EDIT"] = "products.edit";
    UserPermission["PRODUCTS_DELETE"] = "products.delete";
    UserPermission["PRODUCTS_ARCHIVE"] = "products.archive";
    UserPermission["PRODUCTS_MANAGE_CATEGORIES"] = "products.manageCategories";
    // User Management
    UserPermission["USERS_VIEW"] = "users.view";
    UserPermission["USERS_CREATE"] = "users.create";
    UserPermission["USERS_EDIT"] = "users.edit";
    UserPermission["USERS_DELETE"] = "users.delete";
    UserPermission["USERS_ARCHIVE"] = "users.archive";
    UserPermission["USERS_MANAGE_PERMISSIONS"] = "users.managePermissions";
    // Group Management
    UserPermission["GROUPS_VIEW"] = "groups.view";
    UserPermission["GROUPS_CREATE"] = "groups.create";
    UserPermission["GROUPS_EDIT"] = "groups.edit";
    UserPermission["GROUPS_DELETE"] = "groups.delete";
    // Comments
    UserPermission["COMMENTS_VIEW"] = "comments.view";
    UserPermission["COMMENTS_CREATE"] = "comments.create";
    UserPermission["COMMENTS_EDIT"] = "comments.edit";
    UserPermission["COMMENTS_DELETE"] = "comments.delete";
    // Statistics
    UserPermission["STATISTICS_VIEW"] = "statistics.view";
    UserPermission["STATISTICS_EXPORT"] = "statistics.export";
    // System Settings
    UserPermission["SETTINGS_VIEW"] = "settings.view";
    UserPermission["SETTINGS_EDIT"] = "settings.edit";
    UserPermission["SETTINGS_EDIT_DOCUMENT"] = "settings.editDocument";
    UserPermission["NOTIFICATIONS_MANAGE"] = "notifications.manage";
    // Email Communication
    UserPermission["EMAIL_ACCESS"] = "email.access";
    UserPermission["EMAIL_ACCOUNTS_MANAGE"] = "email.accountsManage";
})(UserPermission || (exports.UserPermission = UserPermission = {}));
